'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'OperationTypeRestService',
    function($modal, OperationTypeRestService) {
        return {
            select: select,
            create: create,
            edit: edit,
            api: OperationTypeRestService,
        };

        function select(tax, filters, def) {
            return $modal.open({
                template: require('../view/operation-type-modal-select.html'),
                controller: 'OperationTypeModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    type: function() {
                        return tax;
                    },
                    typeFilters: function() {
                        return filters != null ? filters : [];
                    },
                    def: () => {
                        return {
                            org: def.org,
                        };
                    },
                },
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/operation-type-modal-create.html'),
                controller: 'OperationTypeModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    type: function() {
                        return {
                            org: (function(def) {
                                if (def != null && def.org != null) {
                                    return def.org;
                                }
                            })(def),
                        };
                    },
                },
            });
        }

        function edit(tax) {
            return $modal.open({
                template: require('../view/operation-type-modal-create.html'),
                controller: 'OperationTypeModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    type: function() {
                        return tax;
                    },
                },
            });
        }
    }];
